import { Component, Input, OnInit, inject } from '@angular/core';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Loan } from 'src/model/loan.model';

@Component({
    selector: 'app-previous-approved-request-card',
    templateUrl: './previous-approved-request-card.component.html',
    styleUrls: ['./previous-approved-request-card.component.scss'],
    standalone: false
})
export class PreviousApprovedRequestCardComponent implements OnInit {
  private sharedService = inject(SharedService);

  // @Input() request: LoanRequest
  @Input() loan: Loan
  @Input() epfAmount: number

  ngOnInit(): void {
  }

  calculateSettlement() {
    let settlement = 0;
    if (this.loan.Scheme == 'EPF') {
      settlement = this.sharedService.calculateEPFSettlementAmountWithCharges(this.loan);
    }
    else
      settlement = this.loan.LegacySettlement;
    return settlement;

  }

  calculateRatio() {
    const settlement = this.calculateSettlement();
    const ratio = (settlement / this.epfAmount) * 100;
    return ratio;

  }
}
